import React, { useCallback, useEffect, useState } from "react";
import { Modal, InputNumber } from "antd";
import { useTranslation } from "react-i18next";
import { FormWrapperInputComponent } from "../../../../common/component/Index";
import * as Func from "../../../../../../helpers/functions";
import Input from "../../../../common/component/Input";
import Wrapper from "../../../../common/component/Wrapper";
import Text from "antd/lib/typography/Text";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";
import TextArea from "antd/lib/input/TextArea";
import "./ModalAddSurcharge.less";

export default function ModalAddSurcharge(props) {
  const { visible, surchargeTypes, onCancel } = props;
  const defaultSurchargeType = surchargeTypes && surchargeTypes.length ? surchargeTypes[0] : null
  const [cost, setCost] = useState();
  const [note, setNote] = useState("");
  const [ftCode, setFTCode] = useState("");
  const [selectedSurchargeType, setSelectedSurchargeType] = useState(defaultSurchargeType);
  const [validation, setValidation] = useState({});
  const { t } = useTranslation();

  const getSurchargeTypeByValue = useCallback((value) => {
    const item = surchargeTypes?.find(f => f.value === value)
    return item || defaultSurchargeType
  }, [surchargeTypes, defaultSurchargeType])

  const validate = () => {
    let validate = {
      required: {
        ftCode: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.order.ftCode`)
        ),
        cost: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.order.surchargeCost`)
        )
      }
    };
    let valueValidate = {};
    const result = Func.multipleValidate(
      { ftCode, cost },
      validate,
      valueValidate
    );
    setValidation(result);
    return Object.keys(result).length < 1;
  };

  const reset = useCallback(() => {
    setCost()
    setNote("")
    setFTCode("")
    setValidation({})
    setSelectedSurchargeType(defaultSurchargeType)
  }, [defaultSurchargeType])

  const onSubmit = () => {
    if (validate()) {
      props.onSubmit({ ftCode, cost, note, selectedSurcharge: selectedSurchargeType });
    }
  };

  useEffect(() => {
    if (visible) {
      reset()
    }
  }, [reset, visible])

  const onFTCodeChange = e => {
    const value = e?.target?.value ?? ""
    setFTCode(value.trim())
  }

  return (
    <>
      <Modal
        className="order-access-trade"
        destroyOnClose={true}
        visible={visible}
        title={t(`item.order.addSurchargeTitle`)}
        onOk={onSubmit}
        onCancel={onCancel}
        okText={t(`action.confirm`)}
      >
        <Wrapper className="m-0 p-0">
          <FormWrapperInputComponent
            isRequired={true}
            isValidation={true}
            dataValidation={cost}
            validation={validation.cost}
            labelTitle={t(`item.order.surchargeCost`)}
          >
            <InputNumber
              className="form-control input-surcharge-cost"
              placeholder=""
              name={`surchargeCost`}
              type="text"
              defaultValue={1000}
              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              onChange={e => setCost(e)}
              value={cost}
              min={1}
            />
          </FormWrapperInputComponent>
          <FormWrapperInputComponent
            labelTitle={t(`item.order.selectSurchargeType`)}
          >
            <AntSelect
              className="select-types"
              showArrow
              mode="single"
              placeholder={Func.capitalizeFirstLetter(
                (
                  t("placeHolderForm.select") +
                  " " +
                  t("item.campaign.channel")
                ).toLowerCase()
              )}
              value={selectedSurchargeType?.value || ""}
              onChange={value => {
                const surcharge = getSurchargeTypeByValue(value)
                setSelectedSurchargeType(surcharge)
              }}
              style={{ width: "100%" }}
            >
              {surchargeTypes.map(surcharge => (
                <AntOption key={surcharge.value} value={surcharge.value}>
                  {surcharge.name}
                </AntOption>
              ))}
            </AntSelect>
          </FormWrapperInputComponent>
          <Text>{t(`item.order.surchargeDesc`)}</Text>
          <FormWrapperInputComponent labelTitle={t(`item.surcharge.note`)}>
            <TextArea
              className="form-control"
              name="note"
              rows={3}
              onChange={e => setNote(e.target.value)}
              value={Func.checkUndefine(note)}
            />
          </FormWrapperInputComponent>
          <FormWrapperInputComponent
            isRequired={true}
            isValidation={true}
            dataValidation={ftCode}
            validation={validation.ftCode}
            labelTitle={t(`item.order.ftCode`)}
          >
            <Input
              placeholder=""
              type={`text`}
              className={`form-control`}
              name="ftCode"
              onChange={onFTCodeChange}
              value={Func.checkUndefine(ftCode)}
            />
          </FormWrapperInputComponent>
        </Wrapper>
      </Modal>
    </>
  );
}
